import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { IoCloseOutline } from "react-icons/io5";
import socialIcon from "../Image/Social-icons1.png";
import emailIcon from "../Image/email-icon.png";
import passIcon from "../Image/pass-icon.png";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import Signup from "./Signup";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
function Login({ onClose }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [activeTab, setActiveTab] = useState("login");
  const { setIsAuth, setOpenLogin } = useAuth();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const savedUser = JSON.parse(localStorage.getItem("user")) || [];

    if (savedUser.length === 0) {
      toast.error("No user found. Please signup first");
      return;
    }

    const matchuser = savedUser.find(
      (user) => data.email === user.email && data.password === user.password,
    );

    if (matchuser) {
      localStorage.setItem("currentUser", JSON.stringify(matchuser));

      localStorage.setItem("isAuth", "true");

      setIsAuth(true);

      toast.success("Login successful");

      onClose();
    } else {
      toast.error("Email or Password not match");
    }

    reset();
  };

  return (
    <div>
      <div className="modal-overlay" onClick={onClose}>
        <div className="signup-box" onClick={(e) => e.stopPropagation()}>
          <div className="signup-header">
            <button
              className={`btn-tab login ${activeTab === "login" ? "active" : ""}`}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>

            <button
              className={`btn-tab signup ${activeTab === "signup" ? "active" : ""}`}
              onClick={() => setActiveTab("signup")}
            >
              Signup
            </button>
            <IoCloseOutline className="close-btn" onClick={onClose} />
          </div>

          {activeTab === "login" ? (
            <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
              <div className=" align-items-start gap-3 form-row">
                <div className="form-field">
                  <div className="d-flex align-items-center gap-2 input-group">
                    <img src={emailIcon} alt="icon" />
                    <input
                      type="email"
                      placeholder="Enter your email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^\S+@\S+$/i,
                          message: "Invalid email",
                        },
                      })}
                    />
                  </div>
                  {errors.email && (
                    <p className="error">{errors.email.message}</p>
                  )}
                </div>

                <div className="form-field">
                  <div className="d-flex align-items-center gap-2 input-group">
                    <img src={passIcon} alt="icon" />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      {...register("password", {
                        required: "Password is required",
                        pattern: {
                          value:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                          message:
                            "Password must contain uppercase, lowercase, number, and special character",
                        },
                      })}
                    />

                    <span
                      className="eye"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                    </span>
                  </div>
                  {errors.password && (
                    <p className="error">{errors.password.message}</p>
                  )}
                </div>
              </div>
              <button type="submit" className="create-btn">
                Create Account
              </button>
              <p className="or-text" style={{ textDecoration: "underline" }}>
                Forgot your password
              </p>
              <p className="or-text">Or Login with</p>

              <div className="social-icons">
                <img src={socialIcon} alt="" />
              </div>
              <p className="login-link mb-0 login-terms">
                By accessing the site, I confirm that I am 18 years old and I
                have read the <span> terms of service</span>
              </p>
              <p className="login-link mb-0">
                Do you have an account?{" "}
                <span onClick={() => setActiveTab("signup")}>Sign Up</span>
              </p>
            </form>
          ) : (
            <Signup
              setActiveTab={setActiveTab}
              onClose={onClose}
              setIsAuth={setIsAuth}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
